// Copyright (c) Move Closer 2022.

import { Component, Prop } from 'vue-property-decorator'

import { logger } from '../../../support'

import AbstractForm from '../molecules/Form/Form.abstract.vue'
import { SimpleFormProps } from '../molecules/Form'

/**
 * @author Javlon Khalomjonov <javlon.kgalimjonov@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl> (edited)
 */
@Component<SimpleFormMixin>({
  name: 'SimpleFormMixin'
})
export class SimpleFormMixin extends AbstractForm {
  @Prop({ type: Boolean, required: false, default: true })
  public readonly dirtyMode!: boolean

  @Prop({ type: String, required: false })
  public readonly heading?: SimpleFormProps['heading']

  @Prop({ type: String, required: false })
  public readonly editLabel?: SimpleFormProps['editLabel']

  @Prop({ type: Boolean, required: false, default: true })
  public readonly simpleFormValidate!: boolean

  @Prop({ type: Boolean, required: false, default: true })
  public readonly canEdit!: boolean

  public isDirty: boolean = !this.dirtyMode
  public isEditing: boolean = false

  public markAsDirty (): void {
    if (!this.isEditing) {
      return
    }

    this.isDirty = true
  }

  /**
   * Submits the form.
   */
  public async submit (): Promise<void> {
    try {
      // eslint-disable-next-line
      // @ts-ignore
      AbstractForm.options.methods.submit.call(this)
    } catch (e) {
      logger(e, 'error')
    }

    if (this.errors === null) {
      this.isEditing = false
    }
  }
}
